import React, { useEffect } from "react";
import { Typography, Divider, Tag } from "antd";
import { Link, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../components/ui/tabs";
import { useTranslation } from "../i18n/useTranslation";

const { Title, Text, Paragraph } = Typography;

const Technology = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#core-technology") {
      const timer = setTimeout(() => {
        const el = document.getElementById("core-technology");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-blue-300 to-indigo-100 py-16 pt-20 pb-10">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <Title level={1} className="mb-4">
                {t("techHeroTitle")}
              </Title>
              <div className="text-gray-600 py-6 text-base">
                {t("techHeroDesc")}
              </div>
              {/* <div className="flex gap-4 mt-2 mb-6">
                <Button variant="blue-griadient" size="lg">
                  了解更多
                </Button>
                <Button variant="secondary" size="lg">
                  联系我们
                </Button>
              </div> */}
            </div>
            <div className="md:w-1/2 max-w-[560px]">
              <img src={require("../assets/img/solution_hero.webp")} />
            </div>
          </div>
        </div>
      </section>

      {/* What is AI Chip Section */}
      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              {t("techWhatIsAIChipTag")}
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              {t("techWhatIsAIChipTitle")}
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              {t("techWhatIsAIChipDesc")}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-8 bg-blue-50 rounded-lg">
                <h3 className="mb-2 text-lg font-bold text-slate-800">
                  {t("techFeature1Title")}
                </h3>
                <p className="text-slate-600">
                  {t("techFeature1Desc")}
                </p>
              </div>
              <div className="p-8 bg-blue-50 rounded-lg">
                <h3 className="mb-2 text-lg font-bold text-slate-800">
                  {t("techFeature2Title")}
                </h3>
                <p className="text-slate-600">
                  {t("techFeature2Desc")}
                </p>
              </div>
              <div className="p-8 bg-blue-50 rounded-lg">
                <h3 className="mb-2 text-lg font-bold text-slate-800">
                  {t("techFeature3Title")}
                </h3>
                <p className="text-slate-600">
                  {t("techFeature3Desc")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Technology Points + Comparison (unified gray block) */}
      <section id="core-technology" className="bg-gray-100 pt-24 md:pt-24 pb-12 md:pb-16">
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              {t("techCoreTechTag")}
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              {t("techCoreTechTitle")}
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  {t("techCorePoint1Title")}
                </h3>
              </div>
              <p className="text-slate-600">
                {t("techCorePoint1Desc")}
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  {t("techCorePoint2Title")}
                </h3>
              </div>
              <p className="text-slate-600">
                {t("techCorePoint2Desc")}
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  {t("techCorePoint3Title")}
                </h3>
              </div>
              <p className="text-slate-600">
                {t("techCorePoint3Desc")}
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">{t("techCorePoint4Title")}</h3>
              </div>
              <p className="text-slate-600">
                {t("techCorePoint4Desc")}
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  {t("techCorePoint5Title")}
                </h3>
              </div>
              <p className="text-slate-600">
                {t("techCorePoint5Desc")}
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">{t("techCorePoint6Title")}</h3>
              </div>
              <p className="text-slate-600">
                {t("techCorePoint6Desc")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Comparison */}
      <section className="bg-gray-100 pt-4 pb-24 md:pb-32">
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              {t("techComparisonTitle")}
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              {t("techComparisonDesc")}
            </p>
          </div>
          <div className="overflow-x-auto max-w-4xl mx-auto rounded-lg overflow-hidden shadow-md bg-white">
            <table className="w-full min-w-[480px] border-collapse table-fixed">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50">
                  <th className="py-4 px-6 text-left text-sm font-semibold text-slate-800 w-[28%]">{t("techComparisonTableHeader1")}</th>
                  <th className="py-4 px-6 text-left text-sm font-semibold text-slate-800 w-[36%]">{t("techComparisonTableHeader2")}</th>
                  <th className="py-4 px-6 text-left text-sm font-semibold text-slate-800 w-[36%]">{t("techComparisonTableHeader3")}</th>
                </tr>
              </thead>
              <tbody className="text-slate-600">
                <tr className="border-b border-slate-100">
                  <td className="py-4 px-6 font-medium text-slate-800 align-top">{t("techComparisonRow1Label")}</td>
                  <td className="py-4 px-6 align-top">{t("techComparisonRow1Col2")}</td>
                  <td className="py-4 px-6 align-top">{t("techComparisonRow1Col3")}</td>
                </tr>
                <tr className="border-b border-slate-100">
                  <td className="py-4 px-6 font-medium text-slate-800 align-top">{t("techComparisonRow2Label")}</td>
                  <td className="py-4 px-6 align-top">{t("techComparisonRow2Col2")}</td>
                  <td className="py-4 px-6 align-top">{t("techComparisonRow2Col3")}</td>
                </tr>
                <tr className="border-b border-slate-100">
                  <td className="py-4 px-6 font-medium text-slate-800 align-top">{t("techComparisonRow3Label")}</td>
                  <td className="py-4 px-6 align-top">{t("techComparisonRow3Col2")}</td>
                  <td className="py-4 px-6 align-top">{t("techComparisonRow3Col3")}</td>
                </tr>
                <tr>
                  <td className="py-4 px-6 font-medium text-slate-800 align-top">{t("techComparisonRow4Label")}</td>
                  <td className="py-4 px-6 align-top">{t("techComparisonRow4Col2")}</td>
                  <td className="py-4 px-6 align-top">{t("techComparisonRow4Col3")}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Application Scenarios */}
      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              {t("techApplicationTag")}
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              {t("techApplicationTitle")}
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              {t("techApplicationDesc")}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                {t("techApplication1Title")}
              </h3>
              <p className="text-slate-600">
                {t("techApplication1Desc")}
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                {t("techApplication2Title")}
              </h3>
              <p className="text-slate-600">
                {t("techApplication2Desc")}
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                {t("techApplication3Title")}
              </h3>
              <p className="text-slate-600">
                {t("techApplication3Desc")}
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                {t("techApplication4Title")}
              </h3>
              <p className="text-slate-600">
                {t("techApplication4Desc")}
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                {t("techApplication5Title")}
              </h3>
              <p className="text-slate-600">
                {t("techApplication5Desc")}
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                {t("techApplication6Title")}
              </h3>
              <p className="text-slate-600">
                {t("techApplication6Desc")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Development Platform */}
      <section className="py-24 bg-gray-100">
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              {t("techPlatformTag")}
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              {t("techPlatformTitle")}
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              {t("techPlatformDesc")}
            </p>
          </div>
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="md:w-1/2">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center text-white bg-blue-600 rounded-full flex-shrink-0 mt-1">
                    1
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-800">
                      {t("techPlatform1Title")}
                    </h3>
                    <p className="text-slate-600">
                      {t("techPlatform1Desc")}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center text-white bg-blue-600 rounded-full flex-shrink-0 mt-1">
                    2
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-800">
                      {t("techPlatform2Title")}
                    </h3>
                    <p className="text-slate-600">
                      {t("techPlatform2Desc")}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center text-white bg-blue-600 rounded-full flex-shrink-0 mt-1">
                    3
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-800">
                      {t("techPlatform3Title")}
                    </h3>
                    <p className="text-slate-600">
                      {t("techPlatform3Desc")}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center text-white bg-blue-600 rounded-full flex-shrink-0 mt-1">
                    4
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-800">
                      {t("techPlatform4Title")}
                    </h3>
                    <p className="text-slate-600">
                      {t("techPlatform4Desc")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:w-1/2">
              <img
                src={require("../assets/img/ai_platforms.webp")}
                alt="开发平台"
                className="rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Future Vision */}
      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              {t("techFutureTag")}
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              {t("techFutureTitle")}
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              {t("techFutureDesc")}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-8 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow-md">
              <h3 className="mb-4 text-xl font-bold text-slate-800">
                {t("techFuture1Title")}
              </h3>
              <p className="text-slate-600">
                {t("techFuture1Desc")}
              </p>
            </div>
            <div className="p-8 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow-md">
              <h3 className="mb-4 text-xl font-bold text-slate-800">
                {t("techFuture2Title")}
              </h3>
              <p className="text-slate-600">
                {t("techFuture2Desc")}
              </p>
            </div>
            <div className="p-8 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow-md">
              <h3 className="mb-4 text-xl font-bold text-slate-800">
                {t("techFuture3Title")}
              </h3>
              <p className="text-slate-600">
                {t("techFuture3Desc")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Technology;
